import { APP_ID, ApplicationConfig, LOCALE_ID, importProvidersFrom, provideExperimentalZonelessChangeDetection, provideAppInitializer, inject } from "@angular/core";

import { provideHttpClient, withFetch } from "@angular/common/http";
import { Title, provideClientHydration, withHttpTransferCacheOptions } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { CookieService } from "ngx-cookie-service";
import { AppRoutingModule } from "./app-routing.module";
import { PipesModule } from "./modulos/pipes/pipes.module";
import { ConfigService } from "./servicios/config/config.service";
import { DynamicSocialLoginService } from "./servicios/dynamic-social-login.service";
import { GaModule } from "./ga.module";

/**
 * Inicializa la configuración de la aplicación antes de que se cargue la aplicación.
 * @param appConfig - El servicio de configuración de la aplicación.
 * @returns devuelve la configuración de la aplicación.
 */
export function initConfig(appConfig: ConfigService) {
  return () => appConfig.loadConfigPrensa();
}

export function socialAuthConfig(socialLoginService: DynamicSocialLoginService) {
  return socialLoginService.initializeSocialLogin();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const configService = inject(ConfigService);
      return initConfig(configService)();
    }),
    {
      provide: "SocialAuthServiceConfig",
      useFactory: socialAuthConfig,
      deps: [DynamicSocialLoginService],
    },
    // Proveedores básicos
    { provide: APP_ID, useValue: "serverApp" },
    { provide: LOCALE_ID, useValue: "es" },
    // Módulos importados
    importProvidersFrom(AppRoutingModule, GaModule, PipesModule),
    // Servicios standalone
    Title,
    CookieService,
    // Configuraciones experimentales y modernas
    provideExperimentalZonelessChangeDetection(),
    provideClientHydration(withHttpTransferCacheOptions({ includePostRequests: true })),
    provideAnimations(),
    provideHttpClient(withFetch()),
    // provideServiceWorker("ngsw-worker.js", {
    //   enabled: false,
    //   registrationStrategy: "registerWhenStable:30000", // Optimización de estrategia
    // }),
  ],
};
